import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import '../styles/LegalPages.css';

const DatenschutzPage = () => (
  <>
    <Helmet>
      <title>Datenschutzerklärung | DynaStoxx</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div className="legal-container">
      <div className="legal-card">
        <h1>Datenschutzerklärung</h1>
        <p className="legal-intro">
          Der Schutz deiner Daten ist uns wichtig. Diese Erklärung beschreibt, welche personenbezogenen Daten beim Besuch
          und bei der Nutzung von DynaStoxx verarbeitet werden, zu welchem Zweck und auf welcher Rechtsgrundlage.
        </p>

        <section>
          <h2>1. Verantwortlicher</h2>
          <p>
            Christian Lamping<br />Mühlenstraße 19<br />49429 Visbek<br />Deutschland
          </p>
          <p>Kontakt über das <a href="#kontakt">Kontaktformular</a> (siehe auch <Link to="/impressum">Impressum</Link>).</p>
        </section>

        <section>
          <h2>2. Hosting und Server-Logfiles</h2>
          <p>
            Diese Website wird auf Servern in Deutschland betrieben. Beim Aufruf werden technisch notwendige Daten
            (IP-Adresse, Datum und Uhrzeit, aufgerufene Seite, Browsertyp, Referrer) in Server-Logfiles verarbeitet.
            Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO zur Sicherstellung eines stabilen und
            sicheren Betriebs. Logdaten werden nach kurzer Zeit automatisch gelöscht.
          </p>
        </section>

        <section>
          <h2>3. Nutzerkonto und Anmeldung (Firebase Authentication)</h2>
          <p>
            Für Portfolio-Funktionen kannst du ein Konto anlegen. Die Anmeldung erfolgt über Firebase Authentication,
            einen Dienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Dabei werden deine
            E-Mail-Adresse, ein gehashtes Passwort bzw. bei „Mit Google anmelden“ die von Google übermittelte Kontokennung
            sowie technische Sitzungsdaten verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
            Du kannst dein Konto jederzeit über das Kontaktformular löschen lassen.
          </p>
        </section>

        <section>
          <h2>4. Portfolio- und Nutzungsdaten</h2>
          <p>
            Wenn du Aktien zu deinem Portfolio hinzufügst, speichern wir die gewählten Wertpapiere, Stückzahlen,
            Kaufdaten und deine bevorzugte Währung, verknüpft mit deiner Konto-ID. Diese Daten dienen ausschließlich
            der Bereitstellung der Portfolio-Funktionen (Art. 6 Abs. 1 lit. b DSGVO) und werden mit Löschung deines Kontos entfernt.
          </p>
        </section>

        <section>
          <h2>5. Kontaktformular</h2>
          <p>
            Bei einer Anfrage über das Kontaktformular verarbeiten wir Name, E-Mail-Adresse und Nachricht, um deine
            Anfrage zu beantworten (Art. 6 Abs. 1 lit. b und f DSGVO). Die Daten werden gelöscht, sobald die Anfrage
            abschließend bearbeitet ist und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
          </p>
        </section>

        <section>
          <h2>6. Reichweitenmessung (Google Analytics for Firebase)</h2>
          <p>
            Zur Verbesserung des Angebots nutzen wir Google Analytics for Firebase (Google Ireland Limited). Dabei werden
            pseudonymisierte Nutzungsereignisse (z. B. aufgerufene Seiten, Suchvorgänge, Gerätetyp) mit gekürzter IP-Adresse
            verarbeitet. Google kann diese Daten auch auf Servern in den USA verarbeiten; Grundlage hierfür ist das
            EU-U.S. Data Privacy Framework sowie Standardvertragsklauseln. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
            Du kannst der Erfassung widersprechen, indem du in deinem Browser JavaScript-Tracking blockierst oder ein
            Browser-Add-on zur Deaktivierung von Google Analytics verwendest.
          </p>
        </section>

        <section>
          <h2>7. Werbung (Google AdSense)</h2>
          <p>
            Diese Website kann Anzeigen über Google AdSense (Google Ireland Limited) einbinden. AdSense kann Cookies und
            vergleichbare Technologien einsetzen, um Anzeigen auszuliefern und deren Wirksamkeit zu messen. Personalisierte
            Werbung wird nur mit deiner Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) ausgespielt. Einstellungen kannst du unter{' '}
            <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">adssettings.google.com</a> anpassen.
          </p>
        </section>

        <section>
          <h2>8. Externe Schriften und Icons</h2>
          <p>
            Zur einheitlichen Darstellung werden Schriften von Google Fonts und Icons von Font Awesome über das Content Delivery
            Network cdnjs (Cloudflare) geladen. Dabei wird deine IP-Adresse an den jeweiligen Anbieter übermittelt
            (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
        </section>

        <section>
          <h2>9. Lokaler Speicher</h2>
          <p>
            Zur Aufrechterhaltung deiner Anmeldung wird ein Sitzungs-Token im lokalen Speicher deines Browsers abgelegt.
            Dieser ist für die Funktion des Kontos technisch erforderlich und wird beim Abmelden gelöscht.
          </p>
        </section>

        <section>
          <h2>10. Deine Rechte</h2>
          <p>
            Du hast das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der
            Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch (Art. 21). Eine erteilte Einwilligung
            kannst du jederzeit widerrufen. Zudem steht dir ein Beschwerderecht bei einer Datenschutzaufsichtsbehörde zu,
            z. B. bei der Landesbeauftragten für den Datenschutz Niedersachsen.
          </p>
        </section>

        <section>
          <h2>11. Änderungen</h2>
          <p>Wir passen diese Erklärung an, wenn sich Dienste oder Rechtslage ändern. Stand: September 2026.</p>
        </section>
      </div>
    </div>
  </>
);

export default DatenschutzPage;
